/**
 * gets number of days difference between today and date
 * @param  {string} date
 * @return {number}
 */
export const getDifferenceInDays = ({ date }) => {
  const differenceInTime = new Date().getTime() - new Date(date).getTime();
  return Math.floor(differenceInTime / (1000 * 3600 * 24));
};
